import $ from 'jquery';
import _ from 'underscore';
import Pagination from '../pagination/pagination';
import Product from '../product/product';
import heightAnimate from '../../scripts/util/animate/heightAnimate';
import {getProductsByFilters} from '../api/api';

export default class ProductList {
	constructor(options) {
		const defaults = {
			el: '.js-product-list',
			dom: {
				filter: '.js-product-list-filter',
				tablet: '.js-filter-tablet',
				filterCheckbox: '.js-filter-item',
				productContainer: '.js-products-container',
				productItem: '.js-products-item',
				filterItem: '.js-filter-checkbox',
				filterList: '.js-filter-list',
				productsSort: '.js-products-sort',
				selectItem: '.js-select-item',
				selectInput: '.js-select-input',
				productsCount: '.js-products-count',
				mobileCount: '.js-mobile-count',
				showMore: '.js-show-more',
				showDesc: '.js-show-desc',
				desc: '.js-desc',
				clearFilters: '.js-filter-clear'
			},
			classes: {
				catalog: {
					state: {
						open: 'product-list_state_open'
					}
				},
				pagination: {
					state: {
						active: 'pagination__link_state_active'
					}
				}
			},
			queryUrl: '/assets/json/products.json'
		};





		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);

	}

	getDom() {
		const mustacheStyleSyntax = {
			evaluate: /\{\{(.+?)\}\}/g,
			interpolate: /\{\{=(.+?)\}\}/g,
			escape: /\{\{-(.+?)\}\}/g
		};

		let dom;
		dom = this.options.dom;

		this.$filter = $(this.options.dom.filter);
		this.$tablet = $(this.options.dom.tablet);
		this.open = this.options.classes.catalog.state.open;

		this.$productTmpl = _.template(_.unescape($('#productTmpl').html().trim()), mustacheStyleSyntax);
		this.$productItem = this.getEl(dom.productItem).eq(0).clone().empty();
		this.$filterItem = this.getEl(dom.filterItem);
		this.$filterList = this.getEl(dom.filterList);
		this.$productsSort = this.getEl(dom.productsSort);
		this.$showMoreButton = this.getEl(dom.showMore);
		this.$showDesc = this.getEl(dom.showDesc);
		this.$desc = this.getEl(dom.desc);
		this.$productsCount = this.getEl(dom.productsCount);
		this.$mobileCount = this.getEl(dom.mobileCount);
		this.$categorySelectText = $('.js-product-list-category-mobile .js-select-current-text');
		this.$categorySelectInput = $('.js-product-list-category-mobile .js-select-input');
		this.currentPage = 0;
		this.pagination = new Pagination();
		this.pagination.$el.on('changePage', (e, page) => { this.setPage(page); });
		this.product = new Product();
		this.updatePage = true;
		this.showCount = 30;
		this.showCountStep = 30;
		this.showMoreType = false;

		this.$resetFiltersButton = this.getEl(dom.clearFilters);

		this.$resetFiltersButton.on('click', e => this.resetFilters(e));
		this.$mobileCount.on('click', this.closeSelect);
		this.$filterItem.on( 'change', e => { this.clickFilter(e); });
		this.$showMoreButton.on('click', e => { this.showMore(e); });
		this.$showDesc.on('click', () => { this.showDescription(); });
		this.$productsSort.find(this.options.dom.selectItem).on('click', e => { this.clickFilter(e); });
		return this;
	}

	iterateByEachChecked(doit) {
		this.$filterItem.each((index, item) => {
			if ($(item).data('visible')) {
				$(item).find('input:checked').each(( i, checkbox ) => {
					doit(checkbox);
				});
			}
		});
	}

	unCheck(checkbox) {
		$(checkbox).attr('checked', false);
	}

	resetFilters() {
		this.iterateByEachChecked(this.unCheck);
		this.clickFilter();
		this.$categorySelectText.text('Категории');
		this.$categorySelectInput.attr('value', '');
	}

	closeSelect = () => {
		this.$el.removeClass(this.open);
	};

	getEl(element) {
		return this.$el.find(element);
	}

	renderProduct = data => {
		const self = this;
		const $container = self.$el.find(self.options.dom.productContainer);
		if (!this.$showMoreButton) {
			self.$el.find(self.options.dom.productContainer).empty();
		}

		data.items.forEach( item => {

			const $prod = $(self.$productTmpl({product: item}));
			const $newItem = self.$productItem.clone();

			$newItem.append($prod);
			$container.append($newItem);
		});

		self.renderFilters(data.filters);

		this.$productsCount.text(data.count + ' товаров');
		this.$mobileCount.find('span').text('Показать ' + data.count + ' товаров');

		if (this.updatePage) {
			if (data.pageCount === 1) {
				this.pagination.$el.hide();
			} else if (!this.byShowMoreClick) {
				this.pagination.$el.show();
				this.pagination.update(data.pageCount, 1);
				this.updatePage = false;
			}
		}

		if ( data.count <= this.showCount ) {
			this.$showMoreButton.hide();
		}
		this.product = new Product();
		this.product.render();
	}

	renderFilters(filters) {
		const self = this;

		self.$filterItem.each((index, item) => {
			$(item).attr('data-visible', false);

			filters.forEach(filter => {
				if ( $(item).find('[data-id=' + filter.dataId + ']').length ) {
					$(item).attr('data-visible', true);
				}
			});

		});

		filters.forEach(item => {
			$(item).find('[data-id=' + item.dataId + ']').each((index, filter) => {
				$(filter).attr('data-visible', true);
			});
		});

		self.setVisible();
	}

	setVisible() {
		// const self = this;

		// self.$filterItem.each(function () {
		//
		// 	// if ($(this).data('visible')) {
		// 	// 	$(this).css('display', '');
		// 	// } else {
		// 	// 	$(this).css('display', 'none');
		// 	// }
		// });

		// self.renderFilterGroups();
	}


	renderFilterGroups() {
		// const self = this;

		// self.$filterList.each((index, item) => {
		// 	if ($(item).find(self.options.dom.filterItem + '[data-visible="true"]').length === 0) {
		// 		$(item).css('display', 'none');
		// 	} else {
		// 		$(item).css('display', '');
		// 	}
		// });

	}

	query(data) {
		getProductsByFilters(data)
			.then(this.renderProduct)
			.catch(this.renderProduct);
	}

	clickFilter(e) {
		this.updatePage = true;
		this.showMoreType = false;
		this.byShowMoreClick = false;
		this.compileFilters(e);
	}

	compileFilters() {
		const	self = this;
		const	filters = [];
		const	types = [];
		const	data = {};

		this.iterateByEachChecked(checkbox => {
			const $checkbox = $(checkbox);
			filters.push({
				id: $checkbox.data('id'),
				type: $checkbox.data('type'),
				value: $checkbox.val()
			});
		});

		filters.reduce( (prevItem, currentItem) => {
			if (prevItem && prevItem.type !== currentItem.type) {
				types.push(prevItem.type);
				return currentItem;
			} else if (!prevItem) {
				return currentItem;
			}
		}, 0);

		filters.forEach( item => {
			if (!data[item.type]) {
				data[item.type] = [];
				data[item.type].push(item.id);
			} else {
				data[item.type].push(item.id);
			}
		});

		for (const key in data) {
			if (data.hasOwnProperty(key)) {
				data[key] = data[key].join(', ');
			}
		}

		data.sort = this.$productsSort.find(self.options.dom.selectInput).val();
		data.page = this.currentPage;
		data.count = this.showCount;

		self.query(data);
	}

	setPage(currentPage) {
		this.currentPage = currentPage;
		this.compileFilters();
	}

	showMore() {
		this.showCount += this.showCountStep;
		this.$showMoreButton = true;
		this.byShowMoreClick = true;
		this.compileFilters();
	}



	onClick(e) {
		const $target = $(e.target);
		const $el = $target.closest(this.$el);
		$el.toggleClass(this.open);
	}

	showDescription() {
		this.$showDesc.addClass('disable');
		heightAnimate(this.$desc, 0.4);
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.product.getDom();
			this.$filter.on('click', this.onClick.bind(this));
			if (this.product) {
				this.product.truncateText();
			}
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/product-list/product-list.js
 **/